import Api from './Api';

const abortKey = 'FiBuKontenblaetterApi';
const endpoint = '/fibu/kontenblaetter';

export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint,
            usedParams,
            true,
            false,
            abortKey
        )
    },
    print(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + '/' + 'drucken',
            usedParams,
            true,
            false,
            abortKey
        )
    }
}